import logoWhite from "../../assets/images/logoWhite.png";
import { FaFacebookF } from "react-icons/fa6";
import { FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import creditCart from "../../assets/images/credit.svg";
import { useEffect, useState } from "react";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { Link } from "react-router-dom";

/*

const dummyData = [
  { name: "Belgium", link: "https://novamedshop.be/", code: "be" },
  { name: "Austria", link: "https://novamedshop.at/", code: "at" },
  { name: "Denmark", link: "https://novamedshop.de/", code: "de" },
  { name: "Netherlands", link: "https://novamedshop.nl/", code: "nl" },
  { name: "France", link: "https://novamedshop.fr/", code: "fr" },
  { name: "Poland", link: "https://novamedshop.pl/", code: "pl" },
  { name: "Czech Republic", link: "https://novamedshop.cz/", code: "cz" },
  { name: "Italy", link: "https://novamedshop.it/", code: "it" },
  // { name: "Denmark", link: "https://novamedshop.dk/", code: "dk" },
  { name: "Espanyol", link: "https://novamedshop.es/", code: "es" },
  { name: "Switzerland", link: "https://novamedshop.se/", code: "se" },
  { name: "England", link: "https://novamedshop.co.uk/", code: "co.uk" },
];

*/

const Footer = () => {
  const { t } = useLanguage();
  //const { language } = useLanguage();

  const [categoriesData, setCategoriesData] = useState<any>([]);

  //const filteredData = dummyData?.filter((item: any) => item.code !== language);
  //console.log(filteredData);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getFetcher(
          endpoints.products.getProductCategory
        );
        if (response.result) {
          const categoriesWithSubCategories = await Promise.all(
            response.productCategories.map(async (category: any) => {
              const subCategoriesResponse = await getFetcher(
                endpoints.products.getProductSubCategoriesByCategoryId.replace(
                  "{id}",
                  category.id.toString()
                )
              );
              return {
                ...category,
                subCategories: subCategoriesResponse.result
                  ? subCategoriesResponse.productSubCategories
                  : [],
              };
            })
          );
          setCategoriesData(categoriesWithSubCategories);
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <footer className="text-white relative">
      <div className="bg-[#271A4B] h-auto pb-10 pt-10">
        <div className=" w-11/12 mx-auto flex flex-col gap-y-10 mt-1 px-4">
          {/* logo */}
          <div className="flex justify-start">
            <img
              className="min-w-[320px] sm:w-[480px]"
              src={logoWhite}
              alt="logo"
            />
          </div>

          {/* content */}
          <div className="flex flex-col lg:flex-row w-full gap-10 lg:gap-x-10 justify-between">
            {/* contact */}
            <div className="flex flex-col gap-y-7 flex-1">
              <>
                <div className="flex flex-col gap-y-2">
                  <p className="text-[#A29FC1]">{t("footer", "call")}</p>
                  <a
                    href="tel:+492041 781 1879"
                    className="text-white hover:text-[#FFC633] transition-all hover:underline"
                  >
                    049 - 2041 781 1879
                  </a>
                  <a
                    href="tel:+491634251119"
                    className="text-white hover:text-[#FFC633] transition-all hover:underline"
                  >
                    049 - 163 4251119
                  </a>
                </div>
                <div className="flex flex-col gap-y-2">
                  <p className="text-[#A29FC1]">{t("footer", "contact")}</p>
                  <a
                    href="mailto:info@novamedshop.com"
                    className="text-white hover:text-[#FFC633] transition-all hover:underline"
                  >
                    support@novamedshop.com
                  </a>
                </div>
              </>

              <div className="flex flex-col gap-y-2">
                <p className="text-[#A29FC1]">{t("footer", "follow")}</p>
                <div className="flex gap-x-5 items-center">
                  <a
                    href="https://www.facebook.com/profile.php?id=61569075507890&mibextid=ZbWKwL"
                    className="p-2 rounded-full bg-opacity-[13%] bg-white cursor-pointer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF
                      size={25}
                      className="hover:text-[#FFC633] transition-all"
                    />
                  </a>

                  <a
                    href="https://x.com/novamedshop?t=AXYjBQ7Kn3o4o2gNAQlkDQ&s=09"
                    className="p-2 rounded-full bg-opacity-[13%] bg-white cursor-pointer"
                    aria-label="Twitter"
                  >
                    <FaTwitter
                      size={25}
                      className="hover:text-[#FFC633] transition-all"
                    />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/novamedtc/"
                    className="p-2 rounded-full bg-opacity-[13%] bg-white cursor-pointer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn
                      size={25}
                      className="hover:text-[#FFC633] transition-all"
                    />
                  </a>

                  <a
                    href="https://www.instagram.com/novamedshop/"
                    className="p-2 rounded-full bg-opacity-[13%] bg-white cursor-pointer"
                    aria-label="Instagram"
                  >
                    <FaInstagram
                      size={27}
                      className="hover:text-[#FFC633] transition-all"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="border-r-2 border-[#4D3E76] hidden lg:block"></div>

            {/* popular & categories */}
            <div className="flex-1 block">
              <div className="flex flex-col gap-y-5">
                <p className="text-[#A29FC1]">{t("footer", "categories")}</p>
                <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-2 font-poppins font-normal">
                  {categoriesData?.map((item: any, index: number) => (
                    <div key={index}>
                      <button
                        // href={item.link}
                        onClick={() =>
                          navigate(
                            `/product-categories/${item?.id}?main=${item?.name}`
                          )
                        }
                        className="hover:cursor-pointer hover:underline hover:text-[#FFC633] transition-all !min-w-20 max-w-[150px] break-words text-start"
                      >
                        {item.name}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="border-r-2 border-[#4D3E76] hidden lg:block"></div>

            {/* SSS */}
            <div className="flex-1">
              <div className="flex flex-col gap-y-5">
                <p className="text-[#A29FC1]">{t("footer", "sss")}</p>
                <div className="grid grid-cols-1 gap-5 font-poppins font-normal z-50">
                  <a
                    target="_blank"
                    href="mailto:support@novamed.com?subject=Distributor Application&body=Dear NovamedShop Team,%0A%0AI would like to apply as a distributor for NovamedShop. Please find my company details below:%0A%0ACompany Address: [Enter your company address here]%0AFull Name: [Enter your full name here]%0APhone Number: [Enter your phone number here]%0ATax Number: [Enter your tax number here]%0ATax Office: [Enter your tax office here]%0A%0AThank you for considering my application.%0A%0ARegards,%0A[Your Name]%0A%0Ahttps://api.novamedshop.com.tr/public/uploads/ek_logo.png"
                    className="hover:cursor-pointer hover:underline hover:text-[#FFC633] transition-all !min-w-32 cursor-pointer"
                  >
                    {t("footer", "faq1")}
                  </a>
                  <Link
                    to="/about-us"
                    className="hover:cursor-pointer hover:underline hover:text-[#FFC633] transition-all !min-w-32"
                  >
                    {t("footer", "faq2")}
                  </Link>

                  <Link
                    to="/contracts/privacy_and_security_policy"
                    className="hover:cursor-pointer hover:underline hover:text-[#FFC633] transition-all !min-w-32"
                  >
                    {t("footer", "faq3")}
                  </Link>

                  <Link
                    to="/contracts/distance_selling_contract"
                    className="hover:cursor-pointer hover:underline hover:text-[#FFC633] transition-all !min-w-32"
                  >
                    {t("footer", "faq4")}
                  </Link>
                </div>
              </div>
            </div>

            <div className="border-r-2 border-[#4D3E76] hidden lg:block"></div>

            {/* creaditCart */}
            <div className="flex-1 block !min-w-[200px]">
              <img
                className=" object-cover w-full"
                src={creditCart}
                alt="creditCart"
              />
            </div>
          </div>
        </div>
        <div className=" w-11/12  lg:w-11/12 2xl:w-11/12 mx-auto flex flex-col gap-6 mt-10 -mb-5 px-2">
          <div className=" border-t border-[#4D3E76]"></div>
          <p className=" text-[#A29FC1] font-poppins text-[14px]">
            NovamedShop © 2025 {t("footer", "bottom")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
